import React from "react";

const Header = () => {
  return <h1>GESTION DE TAREAS</h1>;
};

export default Header;
